<section
  [formGroup]="stepForm"
  style="min-height: 350px"
  class="mbs-wizard_form">
  <mbs-alert
    *ngIf="!isRDMode && !isRestore && !isAppAwareEnabled && isVMWare"
    class="mt-3 text-sm {{ elementSelectors.css.appAwareInfoPanel }}"
    [type]="mbsPopupType.warning"
    [icon]="true">
    {{ 'wizards:advanced_settings_app_aware_warning' | i18next }}
  </mbs-alert>

  <ng-container *ngIf="isNBF">
    <mbs-form-group
      *ngIf="isHyperV"
      class="pt-3">
      <mbs-checkbox
        formControlName="useChangeBlockTracking"
        [label]="'wizards:advanced_settings_block_tracking_label' | i18next"
        [id]="elementSelectors.id.CBTCheckbox">
        <ng-container appendLabel>
          <a
            *ngIf="ability.can('read', 'HelpMarketing')"
            class="ml-2"
            href="/AP/Help/backup/hyper-v/cbt-for-hyperv"
            target="_blank">
            {{ 'shared:buttons.learnMore' | i18next }}
          </a>
          <div
            *ngIf="!isCBTAvailable"
            class="cursor-help fa fa-info-circle text-info ml-2"
            tooltipClass="tooltip-lg"
            [attr.data-e2e]="elementSelectors.name.CBTCheckDoxDisableTooltip"
            [container]="'body'"
            [ngbTooltip]="'wizards:advanced_settings_block_tracking_label_disable_tooltip' | i18next"></div>
        </ng-container>
      </mbs-checkbox>
    </mbs-form-group>

    <mbs-form-group
      *ngIf="isVMWare"
      class="{{ isAppAwareEnabled ? '' : 'pt-3' }}"
      [id]="elementSelectors.id.VMWareFormGroup">
      <mbs-radio
        *ngIf="!isAppAwareEnabled"
        formControlName="quiesceType"
        name="vmQuiesceType"
        [id]="elementSelectors.id.quiesceTypeRadio1"
        [label]="'wizards:advanced_settings_try_label' | i18next"
        [value]="vmQuiesceType.TryApplicationConsistent">
        <ng-container appendLabel>
          <span class="ml-2 text-muted">{{ 'wizards:advanced_settings_try_label_append' | i18next }}</span>
        </ng-container>
      </mbs-radio>
      <mbs-radio
        *ngIf="!isAppAwareEnabled"
        formControlName="quiesceType"
        name="vmQuiesceType"
        [id]="elementSelectors.id.quiesceTypeRadio2"
        [label]="'wizards:advanced_settings_must_label' | i18next"
        [value]="vmQuiesceType.MustApplicationConsistent"></mbs-radio>
      <mbs-radio
        *ngIf="!isAppAwareEnabled"
        formControlName="quiesceType"
        name="vmQuiesceType"
        [id]="elementSelectors.id.quiesceTypeRadio3"
        [label]="'wizards:advanced_settings_disable_label' | i18next"
        [value]="vmQuiesceType.Disabled"></mbs-radio>

      <mbs-alert
        *ngIf="!isAppAwareEnabled"
        [type]="mbsPopupType.info"
        [icon]="true"
        class="mt-3">
        {{ 'wizards:advanced_settings_vmware_info_alert_text' | i18next }}
      </mbs-alert>

      <mbs-checkbox
        formControlName="useChangeBlockTracking"
        [label]="useChangedBlockTrackingLabel"
        [id]="elementSelectors.id.CBTCheckbox">
        <ng-container appendLabel>
          <a
            *ngIf="ability.can('read', 'HelpMarketing')"
            class="ml-2"
            href="/AP/Help/backup/vmware/cbt"
            target="_blank">
            {{ 'shared:buttons.learnMore' | i18next }}
          </a>
        </ng-container>
      </mbs-checkbox>
    </mbs-form-group>
  </ng-container>

  <mbs-advanced-options-storage-class-azure-tier
    class="d-block mb-3"
    [isVM]="true"
    [parentForm]="stepForm"
    [advancedOptionsFlags]="advancedOptionsFlags"
    [showStorageClass]="selectedStorage?.StorageType === storageType.AmazonS3 || selectedStorage?.StorageType === storageType.AmazonS3Eu"
    [showAzureTires]="selectedStorage?.StorageType === storageType.Azure"
    [storageClasses]="advancedOptionsStepLogic.StorageClasses"
    [accessTires]="advancedOptionsStepLogic.AccessTires"
    (storageClassChange)="storageClassChangeHandler($event)"
    (azureTierChange)="azureAccessTierChangeHandler($event)"></mbs-advanced-options-storage-class-azure-tier>

  <mbs-form-group *ngIf="!isUnix && isNBF && (!isProxmox || canSyntheticForProxmox) && syntheticFullVisible !== 'Hidden'">
    <mbs-checkbox
      formControlName="syntheticFull"
      (change)="syntheticFullChangeHandler($event)"
      [label]="'wizards:synthetic_full_label' | i18next"
      [subtitle]="'wizards:synthetic_full_subtitle' | i18next"
      [attr.data-e2e]="'synthetic-full-checkbox'"
      [disabledSelf]="syntheticFullVisible === 'Disabled'"></mbs-checkbox>
  </mbs-form-group>

  <mbs-form-group *ngIf="selectedStorage?.StorageType === storageType.AmazonS3 || selectedStorage?.StorageType === storageType.AmazonS3Eu">
    <mbs-checkbox
      formControlName="useS3Acceleration"
      [label]="'wizards:use_s3_label' | i18next"
      [id]="'use-S3-acceleration-checkbox'">
      <ng-container appendLabel>
        <span
          class="cursor-help fa fa-info-circle text-info ml-2"
          [placement]="['right', 'bottom']"
          [ngbTooltip]="'wizards:use_s3_label_tooltip' | i18next"></span>
      </ng-container>
    </mbs-checkbox>
  </mbs-form-group>
</section>

<ng-template #errorSyntheticFull>
  <p>{{ 'wizards:error_synthetic_text' | i18next }}</p>
  <mbs-alert
    [type]="mbsPopupType.warning"
    [icon]="true"
    class="mb-0">
    {{ 'wizards:error_synthetic_alert_text' | i18next }}
  </mbs-alert>
</ng-template>

<ng-template #useChangedBlockTrackingLabel>
  {{ 'wizards:advanced_settings_block_tracking_label' | i18next }}
  <span
    class="cursor-help fa fa-info-circle text-info ml-2"
    tooltipClass="tooltip-xl"
    [placement]="['left', 'bottom-left', 'bottom']"
    [container]="'body'"
    [ngbTooltip]="useChangedBlockTrackingTooltip"></span>
</ng-template>

<ng-template #useChangedBlockTrackingTooltip>
  <dl class="text-start mb-0">
    <dd>
      {{ 'wizards:advanced_settings_block_tracking_tooltip' | i18next }}
    </dd>
    <dd class="mb-0">
      {{ 'wizards:advanced_settings_block_tracking_tooltip_desc' | i18next }}
    </dd>
  </dl>
</ng-template>
